<template>
    <div class="zhb">
        <header class="b-relative">
            <img src="./images/banner.jpg" alt="banner" />
            <img src="./images/0.png" class="cpts-img" alt="" />
        </header>
        <section class="section-box">
            <div style="margin:0 0.15rem">
                <van-tabs
                    v-model="active"
                    scrollspy
                    sticky
                    :offset-top="$showTitle ? 46 : 0"
                >
                    <van-tab title="产品详情">
                        <div class="mainbox">
                            <!-- 产品详情 -->
                            <div class="moudul1">
                                <h2 class="md1-tit">
                                    <span>一旦不幸罹患重疾，该怎么办？</span>
                                </h2>
                                <div class="md1-item">
                                    <h3>直接损失</h3>
                                    <p>
                                        重大疾病的平均治疗费用最高可达
                                        <strong class="sign">80万+</strong>
                                    </p>
                                </div>
                                <div class="md1-item">
                                    <h3>潜在支出</h3>
                                    <ul class="md1-list">
                                        <li>收入损失</li>
                                        <li>后续疗养</li>
                                        <li>孩子养育</li>
                                        <li>父母养老</li>
                                    </ul>
                                </div>
                            </div>
                            <div class="explan md1">
                                <p>
                                    *数据来源：2021年1月17日《扬子晚报》，中国精算师协会2021年发布的《国民防范重大疾病健康教育读本》
                                </p>
                            </div>
                            <div class="moudul2">
                                <div class="md2-item md2-ys1">
                                    <h3>保障时间长</h3>
                                    <p>
                                        一份保障，受用<strong class="sign"
                                            >终身</strong
                                        >
                                    </p>
                                </div>
                                <div class="md2-item md2-ys2">
                                    <h3>覆盖疾病种类多</h3>
                                    <p>
                                        涵盖<strong class="sign">160种</strong
                                        >疾病<br /><span class="m-txe"
                                            >120种重大疾病+40种轻度疾病</span
                                        >
                                    </p>
                                </div>
                                <div class="md2-item md2-ys3">
                                    <h3>轻度疾病多次赔</h3>
                                    <p>
                                        轻症最多可赔付<strong class="sign"
                                            >3</strong
                                        >次
                                    </p>
                                </div>
                                <div class="md2-item md2-ys4">
                                    <h3>轻度疾病豁免</h3>
                                    <p>
                                        首次轻症确诊后<br /><strong class="sign"
                                            >豁免剩余保费</strong
                                        >
                                    </p>
                                </div>
                            </div>
                            <div class="explan md2">
                                <p>
                                    *本页面中所列重大疾病描述如下：<br />
                                    恶性肿瘤（重度）——不包括部分早期恶性肿瘤<br />
                                    严重脑中风后遗症——永久性的功能障碍<br />
                                    心脏瓣膜手术——须切开心脏手术<br />
                                    瘫痪——永久完全<br />
                                    深度昏迷——不包括酗酒或药物滥用所致
                                </p>
                            </div>
                        </div>
                    </van-tab>
                    <van-tab title="投保须知">
                        <div class="product-instruction">
                            <div class="section-title">
                                <h3 class="title">投保须知</h3>
                            </div>
                            <div class="section-main">
                                <table class="product-instable">
                                    <tbody>
                                        <tr>
                                            <th>被保人年龄</th>
                                            <td>出生满28天-60周岁</td>
                                        </tr>
                                        <tr>
                                            <th>保障金额</th>
                                            <td>
                                                10万-60万可选
                                            </td>
                                        </tr>
                                        <tr>
                                            <th>保险期间</th>
                                            <td>
                                                保终身
                                            </td>
                                        </tr>
                                        <tr>
                                            <th>交费期间</th>
                                            <td>10年/20年/30年</td>
                                        </tr>
                                        <tr>
                                            <th>交费方式</th>
                                            <td>年交/月交</td>
                                        </tr>
                                        <tr>
                                            <th>犹豫期</th>
                                            <td>15天</td>
                                        </tr>
                                        <tr>
                                            <th>产品条款</th>
                                            <td>
                                                <a
                                                    :href="
                                                        require('../../common/tiaokuan/zhenxiangkangjianzhongdajibingbaoxian.pdf')
                                                    "
                                                    target="_blank"
                                                    @click="pdfPreview($event)"
                                                    >主险：《招商信诺臻享康健重大疾病保险条款》</a
                                                ><br />
                                                <a
                                                    :href="
                                                        require('../../common/tiaokuan/fujiahuomianbaoxianfeijibingbaoxian.pdf')
                                                    "
                                                    target="_blank"
                                                    @click="pdfPreview($event)"
                                                    >附加险：《招商信诺附加豁免保险费疾病保险》</a
                                                ><br />
                                            </td>
                                        </tr>
                                        <tr>
                                            <th>投保地区</th>
                                            <td id="fname">
                                                广东、北京、上海、江苏、浙江、山东、四川、重庆、湖北、陕西、辽宁、湖南、河南、江西、天津、安徽、福建（不含厦门）
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                                <p class="reminder">
                                    温馨提示：本网页仅供参考，不构成保险合同组成部分，保险责任、责任免除、等待期、理赔要求等重点内容，以条款为准。
                                </p>
                            </div>
                        </div>
                    </van-tab>
                    <van-tab title="理赔流程">
                        <CustomerServiceGuide />
                    </van-tab>
                </van-tabs>
            </div>
        </section>
        <router-link to="" tag="footer">
            <button
                class="btn"
                :class="{ disabled: LGStatus }"
                @click="sendLG(2)"
            >
                {{ LGStatus ? "已预约" : "联系专属顾问" }}
            </button>
        </router-link>
    </div>
</template>

<script>
import mixin from "../../common/mixin.js";
import CustomerServiceGuide from "../../common/customer-service-guide/CustomerServiceGuide.vue";
export default {
    mixins: [mixin],
    components: { CustomerServiceGuide },
    data() {
        return {
            showCase: false,
            active: 0,
            code: "1GZ1DO0501BDDDYY1",
            productName: "臻惠保重大疾病保险产品计划",
            method1: 14,
            method2: 1,
        };
    },
};
</script>
<style>
.zhb .van-tabs__wrap {
    border-bottom: 1px solid #d0d0d0;
}
.zhb .van-tabs {
    background: #f6f6f6;
    box-sizing: border-box;
}
.zhb .van-tab {
    font-size: 0.14rem;
    color: #363636;
}
.zhb .van-tab--active {
    font-size: 0.14rem;
    color: #3aaaf8;
}
.zhb .van-tabs__line {
    width: 0.85rem;
    background: #3aaaf8;
}
.zhb .van-tabs__content {
    background: white;
}
.zhb .head-btn .van-icon {
    top: 0.0134rem;
}
</style>
<style scoped>
.zhb {
    height: 100vh;
    overflow: auto;
    -webkit-overflow-scrolling: touch;
    color: #2d2e2f;
}
.b-relative {
    position: relative;
}
.head-btn {
    position: absolute;
    bottom: 0.46rem;
    left: 0.14rem;
    width: 0.84rem;
    height: 0.23rem;
    font-family: FZLanTingHeiS-R-GB;
    font-weight: bold;
    line-height: 0.23rem;
    text-align: center;
    color: white;
    font-size: 0.11rem;
    background: linear-gradient(0deg, #fea914, #fb8e08);
    border-radius: 0.23rem;
}
.head-content {
    position: absolute;
    width: 1.54rem;
    top: 0.33rem;
    left: 0.16rem;
    font-size: 0.12rem;
    font-family: FZLanTingHeiS-R-GB;
    font-weight: 400;
    color: #ffffff;
    line-height: 0.2rem;
    text-shadow: 0rem 0rem 0rem rgba(118, 192, 251, 0.64);
}
.section-box {
    margin-bottom: 0.2rem;
    padding-bottom: 0.25rem;
    background: url(./images/bg.jpg) no-repeat top center;
    background-size: 100% auto;
    background-color: #204a84;
}
.cpts-img {
    position: absolute;
    left: 50%;
    bottom: 0.2rem;
    transform: translateX(-50%);
    width: 2.7rem;
}
img {
    display: block;
    width: 100%;
}
.content-title {
    font-size: 0.17rem;
    font-family: FZLTCHK;
    font-weight: bold;
    color: #4a4a4a;
}
.content-title_circle {
    display: inline-block;
    height: 0.05rem;
    width: 0.05rem;
    border-radius: 50%;
    margin-right: 0.11rem;
    background: linear-gradient(-28deg, #04abfd, #b8f2ff);
    margin-bottom: 0.02rem;
}
.content-img {
    margin-top: 0.22rem;
    margin-bottom: 0.15rem;
}
.content-min {
    margin-top: 0.2rem;
}
.mainbox {
    padding: 0.18rem 0.08rem 0;
}
/* 产品详情 */
.mainbox .sign {
    font-size: 0.19rem;
    color: #fb7e10;
    font-weight: bold;
}
.moudul1 {
    box-sizing: border-box;
    height: 4.5rem;
    padding: 0.18rem;
    padding-top: 1.3rem;
    background: url(./images/bg1.png) no-repeat center;
    background-size: 3rem 4.5rem;
}
.md1-tit {
    position: relative;
    font-size: 0.16rem;
    line-height: 1.2;
    margin-bottom: 0.08rem;
    color: #2073c0;
    font-weight: bold;
    text-align: center;
}
.md1-tit span {
    position: relative;
    z-index: 2;
}
.md1-tit::before {
    display: block;
    content: "";
    position: absolute;
    left: 0.04rem;
    bottom: 0;
    height: 0.04rem;
    width: 2.5rem;
    border-radius: 0.02rem;
    background: #cee8fb;
    z-index: 1;
}
.md1-item {
    margin-bottom: 0.08rem;
}
.md1-item h3 {
    font-size: 0.13rem;
    color: #fff;
    text-shadow: 1px 0 0.08rem #1c6abf;
    line-height: 0.2rem;
    padding-bottom: 0.1rem;
    text-align: center;
    width: 0.7rem;
    height: 0.25rem;
    background: url(./images/titbg.png) no-repeat top center;
    background-size: 0.7rem 0.25rem;
}
.md1-item p {
    font-size: 0.14rem;
    color: #222;
    line-height: 0.18rem;
}
.md1-list {
    overflow: hidden;
}
.md1-list li {
    position: relative;
    float: left;
    padding-left: 0.07rem;
    margin-right: 0.08rem;
    font-size: 0.13rem;
    color: #2c2c2c;
    line-height: 0.2rem;
}
.md1-list li:last-child {
    margin-right: 0;
}
.md1-list li::before {
    display: block;
    content: "";
    position: absolute;
    left: 0;
    top: 50%;
    transform: translateY(-50%);
    width: 0.04rem;
    height: 0.04rem;
    background: #2c2c2c;
    border-radius: 50%;
}
.explan {
    font-size: 0.11rem;
    color: #2c2c2c;
    line-height: 1.5;
    margin-top: 0.05rem;
}

.moudul2 {
    box-sizing: border-box;
    height: 4.7rem;
    margin-top: 0.14rem;
    padding: 0.18rem;
    padding-top: 0.7rem;
    background: url(./images/bg2.png) no-repeat top center;
    background-size: 3rem 4.7rem;
}
.md2.explan {
    margin-top: 0.07rem;
    padding-left: 0.08rem;
}
.md2-item {
    box-sizing: border-box;
    position: relative;
    padding-left: 1.2rem;
    padding-top: 0.13rem;
    padding-bottom: 0.12rem;
    min-height: 0.6rem;
    background: url(./images/line.png) no-repeat top center;
    background-size: 2.8rem 0.01rem;
    display: flex;
    display: -webkit-flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
}
.md2-item h3 {
    box-sizing: border-box;
    position: absolute;
    left: 0;
    top: 0.07rem;
    width: 1.2rem;
    height: 0.4rem;
    padding-left: 0.17rem;
    padding-top: 0.1rem;
    font-size: 0.14rem;
    color: #fff;
    line-height: 0.3rem;
    text-shadow: 1px 0 0.04rem #1c6abf;
    background: url(./images/titbg1.png) no-repeat;
    background-size: 100%;
}
.md2-item p {
    font-size: 0.14rem;
    color: #2c2c2c;
    text-align: center;
    line-height: 1;
    font-weight: 600;
}
.md2-item p .m-txe {
    font-size: 0.11rem;
    line-height: 1;
}
.md2-ys3 {
    margin-top: 1.4rem;
}
.md2-ys1 {
    background: none;
}
.md2-ys4 .sign {
    display: block;
    margin-top: 0.03rem;
}
/* 按钮 */
footer {
    padding: 0 0.15rem;
}
.btn {
    width: 100%;
    height: 0.37rem;
    background: #3b97ff;
    border-radius: 0.37rem;
    line-height: 0.37rem;
    border: none;
    font-size: 0.15rem;
    font-weight: bold;
    color: #ffffff;
    margin-bottom: 0.22rem;
    box-shadow: 0rem 0.03rem 0.05rem #3b97ff;
}
.btn.disabled {
    filter: grayscale(1);
}

.product-instruction {
    margin-top: 0.1rem;
    background: #fff;
}
.section-title {
    padding: 0.15rem;
    border-bottom: 1px solid #eee;
}
.section-title .title {
    font-size: 0.16rem;
    color: #333;
    line-height: 0.2rem;
    font-weight: bold;
}
.product-instruction .section-main {
    padding: 0.15rem 0.15rem 0.3rem;
}
.product-instable {
    margin-bottom: 0.15rem;
    border: 1px solid #eee;
    width: 100%;
    font-size: 0.13rem;
    line-height: 0.2rem;
    border-collapse: collapse;
    border-spacing: 0;
}
.product-instable th {
    padding: 0.1rem 0.1rem;
    width: 30%;
    color: #777;
    background: #f5f5f5;
    border: 1px solid #fff;
    font-weight: normal;
}
.product-instable td {
    padding: 0.1rem 0.05rem 0.1rem 0.15rem;
    width: 70%;
    border: 1px solid #eee;
}
.product-instable a {
    color: #3aaaf8;
}
.product-instruction .reminder {
    font-size: 0.11rem;
    color: #999;
}
</style>
